import React, { useState, useMemo } from 'react'
import { CommonButton, CommonMenu } from '@/components/common'
import { SubSection, StyledDemoGrid, DemoComponent } from '../styled.jsx'

export const MenuSection = () => {
  const [anchorElBasic, setAnchorElBasic] = useState(null)
  const [anchorElOrigin, setAnchorElOrigin] = useState(null)

  const items = useMemo(
    () => [
      { label: 'My Profile', onClick: () => {} },
      { label: 'Settings', onClick: () => {} },
      { label: 'Sign Out', onClick: () => {} },
    ],
    []
  )

  return (
    <>
      <SubSection
        title='Common Menu'
        description='Menu attached to any element via anchor, with customizable origins.'
      >
        <StyledDemoGrid>
          <DemoComponent
            label='basic'
            component={
              <>
                <CommonButton
                  id='menu-basic-trigger'
                  label='Open Menu'
                  variant='secondary'
                  onClick={e => setAnchorElBasic(e.currentTarget)}
                />
                <CommonMenu
                  id='menu-basic'
                  anchorEl={anchorElBasic}
                  open={Boolean(anchorElBasic)}
                  onClose={() => setAnchorElBasic(null)}
                  items={items}
                />
              </>
            }
          />

          <DemoComponent
            label='custom origin'
            component={
              <>
                <CommonButton
                  id='menu-origin-trigger'
                  label='Open (Top-Left)'
                  onClick={e => setAnchorElOrigin(e.currentTarget)}
                />
                <CommonMenu
                  id='menu-origin'
                  anchorEl={anchorElOrigin}
                  open={Boolean(anchorElOrigin)}
                  onClose={() => setAnchorElOrigin(null)}
                  items={items}
                  anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                  transformOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                />
              </>
            }
          />
        </StyledDemoGrid>
      </SubSection>
    </>
  )
}
